import Modal from "./Modal";
import Button from "./Button";

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  heading = "Confirm",
  message = "Are you sure?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  confirmProps = {},
  cancelProps = {},
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} heading={heading}>
      <div className="text-center">
        <p className="mb-6">{message}</p>
        <div className="flex justify-center gap-4">
          <Button onClick={onClose} disabled={loading} {...cancelProps}>
            {cancelLabel}
          </Button>
          <Button onClick={onConfirm} loading={loading} {...confirmProps}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
